import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { GetMarketingSchool, UpMarketingStudent } from '../../../api/MarketinService';
import { BlockFetch, DistrictFetch, StateFetch } from '../../../api/LocationService';
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import Footer from '../footer';
import Swal from 'sweetalert2';
import { getSessions } from '../../../api/SessionsService';
import { ToastMain,SweetAlertShow } from '../../master/Master';
import { courseList } from '../../../api/Courses';
import MarketingHeader from './MarketingHeader';

const UpdateMarketingStudent = () => {
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [school, setSchool] = useState([]);
    const location = useLocation();
    const student_data = location?.state?.id
    const [HostelId, setHostelId] = useState("");
    const [allStates, setAllStates] = useState([]);
    const [allDistricts, setAllDistricts] = useState([]);
    const [allBlock, setAllBlock] = useState([])
    const [filteredDistricts, setFilteredDistricts] = useState([]);
    const [selectedStateId, setSelectedStateId] = useState("");
    const [subjects, setSubjects] = useState('')
    const [session, setSession] = useState('');
    const [selectedSession, setSelectedSession] = useState('')
    const [source, setSource] = useState([]);
    const [courses, setCourses] = useState([]);


    const courseFetch = async () => {
        setLoading(true);
        try {
            const response = await courseList();
            if (response.data.status) {
                setCourses(response?.data?.data || []);

            } else {
                // ToastMain.fire({
                //     icon: "info",
                //     title: response?.data?.message || "Something Want Wrong!",
                // });

                SweetAlertShow('info','Warning',response?.data?.message )
            }
        } catch (error) {
            // ToastMain.fire({
            //     icon: "error",
            //     title:
            //         error?.response?.data?.message ||
            //         error?.response?.message ||
            //         "Something Want Wrong!",
            // });

            SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message ?? error?.message)
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        courseFetch()

    }, [])


    const updateStudent = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData(e.target);
            const response = await UpMarketingStudent(formData);
            if (response?.data?.message) {
                ToastMain.fire({
                    icon: "success",
                    title: "updated successfully!",
                });
                navigate(-1);
            } else {
                if (response?.data?.errors) {
                    setError(response?.data?.errors);
                }
                // ToastMain.fire({
                //     icon: "info",
                //     title: response?.data?.message || 'something went wrong',
                // });

                SweetAlertShow('info','Warning',response?.data?.message)
            }
        } catch (error) {
            if (error?.response?.data?.errors) {
                setError(error?.response?.data?.errors);
            }
            // ToastMain.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.message || 'something went wrong'
            // })

            SweetAlertShow('error','Error',error?.response?.data?.message)
        }
    };

    const getSession = async () => {
        try {
            const response = await getSessions();
            if (response.data.status) {
                // console.log("session fetched", response.data);
                const activeSession = response?.data?.data?.find((s) => s?.status == '1')
                setSelectedSession(activeSession?.id)
                setSession(response?.data);
            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.message || 'something went wrong'
                // })

                SweetAlertShow('info','Warning',response?.data?.message )
            }
        } catch (err) {
            // ToastMain.fire({
            //     icon: 'error',
            //     title: err?.response?.data?.message || 'something went wrong'
            // })
            SweetAlertShow('error','Error',err?.response?.data?.message ?? err?.message)
        }
    };

    const getState = async () => {
        setLoading(true);
        try {
            const response = await StateFetch();
            if (response.data) {
                setAllStates(response?.data?.states);

            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.message || 'something went wrong'
                // })

                SweetAlertShow('info','Warning',response?.data?.message)
            }
        } catch (err) {
            // ToastMain.fire({
            //     icon: 'error',
            //     title: err?.response?.data?.message || 'something went wrong'
            // })
            SweetAlertShow('error','Error',err?.response?.data?.message ?? err?.message)
        } finally {
            setLoading(false);
        }
    };

    const getdistrict = async (state = '') => {
        setLoading(true);
        try {
            const response = await DistrictFetch(state);
            if (response.data) {
                setAllDistricts(response?.data?.districts);

            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.message || 'something went wrong'

                // })

                SweetAlertShow('info','Warning',response?.data?.message)
            }
        } catch (err) {
            // ToastMain.fire({
            //     icon: 'error',
            //     title: err?.response?.data?.message || 'something went wrong'
            // })

            SweetAlertShow('error','Error',err?.response?.data?.message ?? err?.message)
        } finally {
            setLoading(false);
        }
    };

    const getblock = async (district = ' ') => {
        setLoading(true);
        try {
            const response = await BlockFetch(district);
            if (response?.data) {
                setAllBlock(response?.data?.blocks);

            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.message || 'something went wrong'
                // })

                SweetAlertShow('info','Warning',response?.data?.message)
            }
        } catch (err) {
            // ToastMain.fire({
            //     icon: 'error',
            //     title: err?.response?.data?.message || 'something went wrong'
            // })

            SweetAlertShow('error','Error', err?.response?.data?.message ?? err?.message)
        } finally {
            setLoading(false);
        }
    };




    const getSource = async () => {
        try {
            const response = await GetMarketingSchool();
            if (response?.data) {
                setSource(response?.data);
            } else {
                // ToastMain.fire({
                //     icon: 'info',
                //     title: response?.data?.message || 'Something went wrong',
                // });

                SweetAlertShow('info','Warning',response?.data?.message)
            }
        } catch (error) {
            // ToastMain.fire({
            //     icon: 'error',
            //     title: error?.response?.data?.message || 'something went wrong',
            // });

            SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
        }
    };



    useEffect(() => {

        getState();
        getSession();
        getSource();
        getdistrict();
        getblock();

    }, [])
    const navigate = useNavigate()
    return (
        <>
            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <Header />
                    <div className="layout-page">
                        <Nav />
                       
                            <div className="container-fluid">
                                <div className="d-flex gap-2">
                                    <MarketingHeader data={'Marketing Portal'}/>
                                    
                                    <div className="card p-5">
                                        <div className="d-flex justify-content-between align-items-center">
                                             <h4 className='text-primary'>Student Update</h4>
                                        <button onClick={(e) => navigate(-1)} className="btn btn-outline-primary mb-3 mt-3">
                                            <i className="bi bi-arrow-left-circle me-1"></i>
                                            Back
                                        </button>
                                        </div>
                                        <form onSubmit={updateStudent}>
                                            

                                            <div className="row">
                                                <input type="hidden" name='id' value={student_data?.id} />
                                                <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <select className="form-select text-capitalize" name="session_id" value={selectedSession} onChange={(e) => setSelectedSession(e.target.value)}>
                                                        {session?.data?.map((sess) => (
                                                            <option key={sess.id} value={sess.id} selected={student_data?.session === sess.session && true}>
                                                                {sess.session} : {sess.status === '1' ? 'Active' : 'Inactive'}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <label>Session</label>
                                                </div>

                                                <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <input className="form-control text-capitalize input-capitalize" type="text" name="name" placeholder="Student Name" defaultValue={student_data?.name} />
                                                    <label>Student Name</label>
                                                    <span className="text-danger">{error?.name ?? ''} </span>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <input className="form-control text-capitalize input-uppercase" type="text" name="fathers_name" placeholder="Father Name" defaultValue={student_data?.fathers_name} />
                                                    <label>Father Name</label>
                                                     <span className="text-danger">{error?.fathers_name ?? ''} </span>
                                                </div>

                                                <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <input className="form-control text-capitalize" type="text" name="mobile" placeholder="Mobile No" defaultValue={student_data?.mobile} />
                                                    <label>Mobile No</label>
                                                      <span className="text-danger">{error?.mobile ?? ''} </span>
                                                </div>
                                                <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <select
                                                        className="form-select text-capitalize"
                                                        name="source_id"
                                                    // value={student_data?.source_id || ""}

                                                    >
                                                        <option value="">
                                                            Select Source
                                                        </option>
                                                        {source?.data?.map((sch) => (
                                                            <option key={sch.id} value={sch.id} selected={student_data?.source_id === sch.id && true}>
                                                                {sch.source_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <label>Select Source</label>
                                                    <span className="text-danger">{error?.source_id ?? ''} </span>
                                                </div>
                                                 <div className="form-floating col-md-6 form-floating-outline mb-4">
                                                    <select
                                                        className="form-select text-capitalize"
                                                        id="course_id"
                                                        name="course_id"
                                                        required
                                                    >

                                                        {courses.map((course) => (
                                                            <option key={course.id} value={course.id} selected={student_data?.course_id === course.id && true}>
                                                                {course.title}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <label htmlFor="course">Select Course</label>
                                                    <span className="text-danger">{error?.course_id ?? ''} </span>
                                                </div>
                                                 <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <select className="form-select text-capitalize" name="edu_level">
                                                        <option selected disabled>Select Last Education</option>
                                                        <option selected={student_data?.edu_level === '9th' && true}> 9th</option>
                                                        <option selected={student_data?.edu_level === '10th' && true}>10th</option>
                                                        <option selected={student_data?.edu_level === '11th' && true}>11th</option>
                                                        <option selected={student_data?.edu_level === '12th' && true}>12th</option>
                                                    </select>
                                                    <label>Last Education</label>
                                                     <span className="text-danger">{error?.course_id ?? ''} </span>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <input className="form-control text-capitalize" type="text" name="alternate_no" placeholder="Alternate No" defaultValue={student_data?.alternate_no} />
                                                    <label>Alternate No</label>
                                                    <span className="text-danger">{error?.alternate_no ?? ''} </span>
                                                </div>
                                                   <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <input className="form-control text-capitalize input-uppercase" type="text" name="village" placeholder="Village" defaultValue={student_data?.village} />
                                                    <label>Village</label>
                                                     <span className="text-danger">{error?.village ?? ''} </span>
                                                </div>
                                                  {/* <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <input className="form-control text-capitalize" type="text" name="tehsil" placeholder="Tehsil" defaultValue={student_data?.tehsil} />
                                                    <label>Tehsil</label>
                                                    <span className="text-danger">{error?.tehsil ?? ''} </span>
                                                </div> */}
                                                  <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <select className="form-select text-capitalize" name="state" onChange={(e) => getdistrict(e.target.value)}>
                                                        <option value="">Select State</option>
                                                        {allStates?.map((state) => (
                                                            <option key={state.id} value={state.name} selected={student_data?.state === state?.name && true}>
                                                                {state.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <label>State</label>
                                                     <span className="text-danger">{error?.state ?? ''} </span>
                                                </div>

                                                <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <select className="form-select text-capitalize" name="district" onChange={(e) => getblock(e.target.value)}>
                                                        <option value="">Select District</option>
                                                        {allDistricts?.map((district) => (
                                                            <option key={district.id} value={district.name} selected={student_data?.district === district?.name && true}>
                                                                {district.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <label>District</label>
                                                    <span className="text-danger">{error?.district ?? ''} </span>
                                                </div>
                                                                         <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                            <input className="form-control" type="text" name="pincode" placeholder="Pincode" />
                                                            <label>Pincode</label>
                                                            <span className='text-danger'>{error?.pincode ?? ''}</span>

                                                        </div>

                                               

                                               
                                            </div>

                                            <div className="row">
                                              

                                                {/* <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <select className="form-select text-capitalize" name="district" onChange={(e) => getblock(e.target.value)}>
                                                        <option value="">Select District</option>
                                                        {allDistricts?.map((district) => (
                                                            <option key={district.id} value={district.name} selected={student_data?.district === district?.name && true}>
                                                                {district.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <label>District</label>
                                                    <span className="text-danger">{error?.district ?? ''} </span>
                                                </div> */}
                                            </div>

                                            <div className="row">
                                                {/* <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <select className="form-select text-capitalize" name="block">
                                                        {allBlock?.map((blk) => (
                                                            <option key={blk.id} value={blk.name} selected={student_data?.block_id === blk.id && true}>{blk.name}</option>
                                                        ))}
                                                    </select>
                                                    <label>Block</label>
                                                    <span className="text-danger">{error?.block ?? ''} </span>
                                                </div> */}

                                             
                                            </div>

                                            <div className="row">
                                              

                                                {/* <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <input className="form-control text-capitalize" type="text" name="address" placeholder="Address" defaultValue={student_data?.address} />
                                                    <label>Address</label>
                                                    <span className="text-danger">{error?.address ?? ''} </span>
                                                </div> */}
                                            </div>

                                            <div className="row">
                                                

                                                <div className="col-md-6 mb-4 form-floating form-floating-outline">
                                                    <input className="form-control text-capitalize input-uppercase" name="description" placeholder="Note" defaultValue={student_data?.description} />
                                                    <label>Note</label>
                                                      <span className="text-danger">{error?.description ?? ''} </span>
                                                </div>
                                            </div>
                                            <div className='d-flex justify-content-end'>
                                                <button type='submit' className='btn btn-primary'>Submit</button>
                                            </div>
                                        </form>
                                    </div>


                                    <Footer />
                                    <div className="content-backdrop fade"></div>
                                </div>
                                
                                </div>
                        
                    </div>
                    <div className="layout-overlay layout-menu-toggle"></div>
                    <div className="drag-target"></div>
                </div>
            </div>
        </>
    )
}

export default UpdateMarketingStudent
